export function sortedItems(items, key = "start_date") {
  return items.sort((a, b) => new Date(a[key]) - new Date(b[key]))
}
